import React from 'react'
import ProjectLayout from '../../components/projectLayout'
import data from '../../content/projects/idModelELearning'

export default function idModelELearning() {
  return <ProjectLayout data={data} />
}
